// Collage prima/dopo dei clienti (volti sfocati per privacy).
// Aggiungi un oggetto per ogni cliente: { src, result, period, alt }
const dimagrimento = {
  result: "Dimagrimento",
  period: "Perdita di grasso e fisico asciutto",
  alt: "Prima e dopo: dimagrimento, volto sfocato per privacy",
};
const tonificazione = {
  result: "Tonificazione",
  period: "Corpo più tonico e definito",
  alt: "Prima e dopo: tonificazione, volto sfocato per privacy",
};

const massa = {
  result: "Massa muscolare",
  period: "Aumento della massa muscolare",
  alt: "Prima e dopo: aumento della massa muscolare, volto sfocato per privacy",
};

export const results = [
  { src: "/results/dimagrimento-05.webp", ...massa },
  { src: "/results/dimagrimento-06.webp", ...dimagrimento },
  { src: "/results/dimagrimento-07.webp", ...massa },
  { src: "/results/massa-01.webp", ...massa },
  { src: "/results/tonificazione-01.webp", ...tonificazione },
  { src: "/results/tonificazione-02.webp", ...tonificazione },
  { src: "/results/dimagrimento-01.webp", ...dimagrimento },
  { src: "/results/dimagrimento-02.webp", ...dimagrimento },
  { src: "/results/dimagrimento-03.webp", ...dimagrimento, alt: "Prima e dopo: dimagrimento" },
  { src: "/results/dimagrimento-04.webp", ...dimagrimento },
];
